import { useState, useCallback } from 'react'
import { apiClient } from '@/lib/api/client'
import type { ClassifyRequest, ClassifyResponse } from '@/lib/api/types'

interface UseClassifyReturn {
  classify: (request: ClassifyRequest) => Promise<ClassifyResponse | null>
  loading: boolean
  error: string | null
  data: ClassifyResponse | null
  reset: () => void
}

export function useClassify(): UseClassifyReturn {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<ClassifyResponse | null>(null)

  const classify = useCallback(async (request: ClassifyRequest) => {
    setLoading(true)
    setError(null)
    setData(null)

    try {
      const result = await apiClient.classify(request)
      setData(result)
      return result
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to classify item'
      setError(errorMessage)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setLoading(false)
    setError(null)
    setData(null)
  }, [])

  return { classify, loading, error, data, reset }
}
